import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.63 11.097A80.12 80.12 0 0 0 13.883 11c-1.93 0-4.221.094-6.873.283a3.135 3.135 0 0 0-2.903 2.877A39.48 39.48 0 0 0 4 17.27c0 1.467.055 2.817.165 4.052a3.135 3.135 0 0 0 2.898 2.85 95.645 95.645 0 0 0 8.41.237l3.262 3.206a1.344 1.344 0 0 0 2.286-.959v-2.53a3.136 3.136 0 0 0 2.523-2.8 45.91 45.91 0 0 0 .165-4.055c0-.718-.014-1.382-.04-1.992a2 2 0 0 1-2.257-.4l-3.782-3.782Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "SMS-Inbound_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 4,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.281 4.571v7.763l-3.596-3.596a.571.571 0 1 0-.808.809l4.563 4.562a.57.57 0 0 0 .827-.002l4.561-4.56a.571.571 0 1 0-.808-.809l-3.596 3.596V4.571a.571.571 0 0 0-1.143 0Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#SMS-Inbound_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3h11v12H17V3Z",
    fill: "#00B388"
  })));
};

var SvgSmsInbound = styled(SvgComponent).withConfig({
  displayName: "SmsInbound__SvgSmsInbound",
  componentId: "sc-1n37g5b-0"
})(["", " ", ""], size, color);
export default SvgSmsInbound;